import { combineReducers } from 'redux'

import ReducerAuth from './ReducerAuth'
import ReducerDrawer from './ReducerDrawer'
import ReducerCustomer from './ReducerCustomer'
import ReducerSearch from './ReducerSearch'
import ReducerFinancial from './ReducerFinancial'
import ReducerPlanTable from './ReducerPlanTable'
import ReducerProductTable from './ReducerProductTable'
import ReducerPlan from './ReducerPlan'
import ReducerProduct from './ReducerProduct'
import ReducerMarketplace from './ReducerMarketplace'
import ReducerFilter from './ReducerFilter'
import ReducerNotification from './ReducerNotification'
import ReducerLog from './ReducerLog'
import ReducerRegister from './ReducerRegister'

export default combineReducers({
  ReducerAuth,
  ReducerDrawer,
  ReducerCustomer,
  ReducerSearch,
  ReducerFinancial,
  ReducerPlanTable,
  ReducerProductTable,
  ReducerPlan,
  ReducerProduct,
  ReducerMarketplace,
  ReducerFilter,
  ReducerNotification,
  ReducerLog,
  ReducerRegister
})
